import {
  FNOL_AvailabilityResponse,
  FNOL_ClaimOwnerOrComplexAvailabilityResponse,
  FNOL_Request,
  FNOL_TaskTypes,
} from '@dispatch/shared/types';
import { dispatchClient } from '../clients';

const FNOL_SERVICE_BASE_URL = 'availability/moi';
const FNOL_COMPLEX_URL = `${FNOL_SERVICE_BASE_URL}/complex`;
const FNOL_CLAIM_OWNER_URL = `${FNOL_SERVICE_BASE_URL}/claimowner`;

export async function intakeAvailability(
  data: FNOL_Request,
  taskType: FNOL_TaskTypes
) {
  try {
    if (taskType === FNOL_TaskTypes.COMPLEX) {
      return intakeAvailabilityComplex(data);
    }

    if (taskType === FNOL_TaskTypes.CLAIM_OWNER) {
      return intakeAvailabilityClaimOwner(data);
    }

    const response = await dispatchClient.post<FNOL_AvailabilityResponse>(
      FNOL_SERVICE_BASE_URL,
      data
    );

    return {
      data: response.data,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      success: false,
    };
  }
}

export async function intakeAvailabilityClaimOwner(data: FNOL_Request) {
  try {
    const response =
      await dispatchClient.post<FNOL_ClaimOwnerOrComplexAvailabilityResponse>(
        FNOL_CLAIM_OWNER_URL,
        data
      );

    return {
      data: response.data,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      success: false,
    };
  }
}

export async function intakeAvailabilityComplex(data: FNOL_Request) {
  try {
    const response =
      await dispatchClient.post<FNOL_ClaimOwnerOrComplexAvailabilityResponse>(
        FNOL_COMPLEX_URL,
        data
      );

    return {
      data: response.data,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      success: false,
    };
  }
}
